module.exports = __webpack_public_path__ + "img/trustpilot-badge.325c41ef.svg";